/**
 * The five stages a scan goes through, numbered in capture order and named as a
 * process — the one list the Processing Status panel, the Reprocess menu, the
 * reprocess messages and the admin Feature Flags page all quote, so a stage is
 * called the same thing everywhere it appears.
 *
 * Keys are the Processing Status item keys (`utils/processStatusItems`), which kept
 * their older names: `initial-structure` is the initial build and
 * `refined-structure` is the LiDAR refinement.
 *
 * The depth-cycle plan (claude-docs/2026-10-30-vision-fixture-stage-plan.md)
 * counted only the structure's own stages, so its "stage 2" is Stage 4 here and
 * its "stage 3" is Stage 5.
 */
export const SCAN_STAGE = Object.freeze({
  'initial-structure': 'Stage 1: Initial build',
  'video-upload': 'Stage 2: Video upload',
  'lidar-upload': 'Stage 3: LiDAR upload',
  'fixture-check': 'Stage 4: Fixture check',
  'refined-structure': 'Stage 5: LiDAR refinement',
});
